import * as React from 'react';
import { useApplicationStore } from '@data';

export const usePatientWebUrl = () => {
  const patientWebUrl = useApplicationStore(({ devTools }) =>
    devTools.patientWebUrl?.replace(/\/+$/, ''),
  );
  return React.useMemo(
    () => ({
      patientWebUrl,
      navigateToPatientWebUrl: () => {
        window.location.href = patientWebUrl;
      },
    }),
    [patientWebUrl],
  );
};
